<div class="doc-publica">

  <!-- ── Doc processor overlay ── -->
  <div class="doc-processor" [class.active]="mostrarModalProcesando">
    <div class="doc-proc-card">
      @if (!procesandoError) {
        <div class="doc-proc-title">Procesando documento...</div>
        <div class="doc-proc-sub">{{ procesandoNombreArchivo }}</div>
        <div class="doc-proc-steps">
          @for (nombre of pasosProcesando; track nombre; let i = $index) {
            <div class="doc-proc-step" [class.dp-done]="i < pasoProcesandoActual" [class.dp-active]="i === pasoProcesandoActual">
              <div class="doc-proc-ico">
                @if (i < pasoProcesandoActual) {
                  <mat-icon>check</mat-icon>
                } @else if (i === pasoProcesandoActual) {
                  <span class="dp-spinner"></span>
                } @else {
                  {{ i + 1 }}
                }
              </div>
              {{ nombre }}
            </div>
          }
        </div>
        <div class="doc-proc-note">No cierres esta ventana</div>
      } @else {
        <div class="doc-proc-err-title">No pudimos procesar este archivo</div>
        <div class="doc-proc-err-sub">Verifica que el archivo no esté dañado e inténtalo nuevamente.</div>
        <button class="btn btn-outlined" (click)="cerrarModalProcesando()">Cerrar</button>
      }
    </div>
  </div>

  <!-- ── Confirmar eliminación ── -->
  <div class="confirm-modal" [class.active]="!!archivoAEliminar">
    <div class="confirm-modal-card">
      <div class="confirm-modal-ico"><mat-icon>delete_outline</mat-icon></div>
      <div class="confirm-modal-title">Eliminar documento</div>
      <div class="confirm-modal-sub">
        ¿Eliminar <strong>{{ archivoAEliminar?.nombre_archivo }}</strong>? Esta acción no se puede deshacer.
      </div>
      <div class="confirm-modal-actions">
        <button class="btn btn-outlined btn-sm" (click)="cancelarEliminar()">Cancelar</button>
        <button class="btn btn-danger btn-sm" (click)="confirmarEliminar()">Eliminar</button>
      </div>
    </div>
  </div>

  @if (paso === 'listo') {
    <header class="sf-header">
      <div class="h-logo"><img [src]="logoUrl" alt="Simpli" /></div>
      <div class="h-div"></div>

      <div class="h-context">
        <span class="h-company">{{ empresaNombre }}</span>
        @if (operacionId) {
          <span class="h-op">Op. N° {{ operacionId }}</span>
        } @else if (simulacionId) {
          <span class="h-op">Simulación N° {{ simulacionId }}</span>
        }
        <span class="h-sub">Completa los requisitos de tu solicitud</span>
      </div>

      <div class="h-div"></div>

      <div class="h-right">
        @if (ejecutivo) {
          <div class="h-exec">
            <div class="h-exec-av">{{ ejecutivoIniciales }}</div>
            <span class="h-exec-name"><strong>{{ ejecutivo.nombre }}</strong> · {{ ejecutivo.rol }}</span>
          </div>
          <div class="h-div" style="margin:0 4px"></div>
        }
        @if (estado) {
          <div class="h-status">
            <span class="h-status-dot"></span>
            {{ estado }}
          </div>
        }
        <span class="h-secure">
          <mat-icon inline="true" style="font-size:13px;">lock</mat-icon>
          Enlace seguro
        </span>
      </div>
    </header>
  }

  <div class="sf-content">

    @if (paso === 'cargando') {
      <div class="doc-publica__estado-vacio">
        <mat-spinner diameter="36"></mat-spinner>
      </div>
    }

    @if (paso === 'invalido') {
      <div class="doc-publica__estado-vacio">
        <mat-icon class="doc-publica__estado-icon">error_outline</mat-icon>
        <h2>Link no válido</h2>
        <p>Este link de carga de documentos no es válido. Pídele a tu ejecutivo que te comparta uno nuevo.</p>
      </div>
    }

    @if (paso === 'expirado') {
      <div class="doc-publica__estado-vacio">
        <mat-icon class="doc-publica__estado-icon">schedule</mat-icon>
        <h2>Este link expiró</h2>
        <p>Por seguridad, este link vale por 24 horas. Pídele a tu ejecutivo que te comparta uno nuevo.</p>
      </div>
    }

    @if (paso === 'listo') {
      <div class="hero-wrap">
        <div class="hero-title">Completa los requisitos de tu solicitud</div>
        <div class="hero-sub">Sube los documentos que falten para avanzar con la evaluación de tu crédito.</div>

        <div class="hero-bottom">
          <div class="hero-bar-col">
            <div class="hero-bar-top">
              <span class="hero-bar-label">Progreso de tu solicitud</span>
              <span class="progress-pct">{{ progresoPct }}%</span>
            </div>
            <div class="progress-bar"><div class="progress-fill" [style.width.%]="progresoPct"></div></div>
          </div>
          <div class="hero-stats">
            <div class="hero-stat"><div class="hero-stat-dot" style="background:var(--ok)"></div><strong>{{ completados }}</strong>&nbsp;completados</div>
            <div class="hero-stat"><div class="hero-stat-dot" style="background:var(--warn)"></div><strong>{{ pendientes }}</strong>&nbsp;pendientes</div>
          </div>
        </div>
      </div>

      <div class="task-grid">
        @for (doc of DOCS_CREDITO; track doc.subtype) {
          @if (subtypeSubiendo === doc.subtype) {
            <div class="task-card" style="border-style:solid;border-color:var(--bgl)">
              <div class="task-body">
                <div class="uc-spinner" style="margin-bottom:8px"></div>
                <div class="task-name">Subiendo documento...</div>
                <div class="task-desc" style="color:var(--td)">{{ doc.nombre }}</div>
              </div>
              <div class="task-action"><span style="font-size:11px;color:var(--td)">Un momento...</span></div>
            </div>
          } @else if (documentos[doc.subtype]?.uploaded) {
            <div class="task-card tc-done">
              <div class="task-body">
                <div class="task-ico task-ico--done">
                  <mat-icon style="color:var(--ok)">check</mat-icon>
                </div>
                <div class="task-name">{{ doc.nombre }}</div>
                <div class="task-desc">{{ documentos[doc.subtype]?.archivos?.[0]?.nombre_archivo }}</div>
                @if (documentos[doc.subtype]?.archivos?.[0]?.tamano_local || documentos[doc.subtype]?.archivos?.[0]?.updated_at) {
                  <div class="task-meta">
                    {{ documentos[doc.subtype]?.archivos?.[0]?.tamano_local }}{{ documentos[doc.subtype]?.archivos?.[0]?.tamano_local && documentos[doc.subtype]?.archivos?.[0]?.updated_at ? ' · ' : '' }}{{ fechaFormateada(documentos[doc.subtype]?.archivos?.[0]?.updated_at ?? null) }}
                  </div>
                }
                <span class="task-badge task-badge--done">Completado</span>

                @if ((documentos[doc.subtype]?.archivos?.length ?? 0) > 1) {
                  <button class="task-more-btn" (click)="$event.stopPropagation(); toggleExpandido(doc.subtype)">
                    {{ documentos[doc.subtype]?.archivos?.length }} archivos
                    <mat-icon inline="true" style="font-size:14px;">{{ docExpandido[doc.subtype] ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </button>
                  @if (docExpandido[doc.subtype]) {
                    <div class="task-file-list">
                      @for (a of documentos[doc.subtype]?.archivos; track a.id) {
                        <div class="task-file-item">
                          <span class="task-file-item__name" [title]="a.nombre_archivo">{{ a.nombre_archivo }}</span>
                          <a class="task-file-item__ver" [class.is-disabled]="verDocumentoLoadingIds.has(a.id)"
                             (click)="$event.stopPropagation(); verDocumento(a)">
                            @if (verDocumentoLoadingIds.has(a.id)) { <span class="uc-spinner uc-spinner--sm"></span> } @else { Ver }
                          </a>
                          @if (a.puede_eliminar) {
                            <a class="task-file-item__eliminar" [class.is-disabled]="eliminarLoadingIds.has(a.id)"
                               (click)="$event.stopPropagation(); eliminarDocumento(doc.subtype, a)" role="button" tabindex="0">
                              @if (eliminarLoadingIds.has(a.id)) { <span class="uc-spinner uc-spinner--sm"></span> } @else { Eliminar }
                            </a>
                          }
                        </div>
                      }
                    </div>
                  }
                }
              </div>
              <div class="task-action">
                <div class="task-links">
                  <a class="task-links__ver"
                     [class.is-disabled]="!!documentos[doc.subtype]?.archivos?.[0] && verDocumentoLoadingIds.has(documentos[doc.subtype]!.archivos[0].id)"
                     (click)="verDocumento(documentos[doc.subtype]?.archivos?.[0])">
                    @if (documentos[doc.subtype]?.archivos?.[0] && verDocumentoLoadingIds.has(documentos[doc.subtype]!.archivos[0].id)) {
                      <span class="uc-spinner uc-spinner--sm"></span>
                    } @else {
                      Ver documento
                    }
                  </a>
                  <span class="task-links__sep">·</span>
                  <a (click)="triggerUpload(doc.subtype)">Agregar otro</a>
                  @if (documentos[doc.subtype]?.archivos?.[0]?.puede_eliminar) {
                    <span class="task-links__sep">·</span>
                    <a class="task-links__eliminar"
                       [class.is-disabled]="!!documentos[doc.subtype]?.archivos?.[0] && eliminarLoadingIds.has(documentos[doc.subtype]!.archivos[0].id)"
                       (click)="eliminarDocumento(doc.subtype, documentos[doc.subtype]?.archivos?.[0])">
                      @if (documentos[doc.subtype]?.archivos?.[0] && eliminarLoadingIds.has(documentos[doc.subtype]!.archivos[0].id)) {
                        <span class="uc-spinner uc-spinner--sm"></span>
                      } @else {
                        Eliminar
                      }
                    </a>
                  }
                </div>
              </div>
            </div>
          } @else {
            <div class="task-card" (click)="triggerUpload(doc.subtype)">
              <div class="task-body">
                <div class="task-ico task-ico--doc">
                  <mat-icon style="color:#7B1FA2">description</mat-icon>
                </div>
                <div class="task-name">{{ doc.nombre }}</div>
                <div class="task-desc">{{ doc.descripcion }}</div>
                <span class="task-badge task-badge--doc">Documento</span>
                <div class="task-meta">Acepta PDF, Excel e imágenes · Máx. 10 MB</div>
              </div>
              <div class="task-action">
                <button class="btn btn-outlined btn-sm btn-full" (click)="$event.stopPropagation(); triggerUpload(doc.subtype)">
                  <mat-icon>upload</mat-icon>
                  <span>Subir archivo</span>
                </button>
              </div>
            </div>
          }

          <input type="file" [id]="'doc-upload-' + doc.subtype"
            (change)="onFileSelected($event, doc.subtype)" style="display:none"
            accept=".pdf,.xls,.xlsx,.jpg,.jpeg,.png,.heic" />
        }
      </div>
    }

  </div>
</div>
